import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../../../../../../../../../components/Tooltip';
import Spinner from '../../../../../../../../../components/Loaders/Spinner';

const CustomRate = ({ rate, isLoading, locked, onChange, onBlur, sync }) => (
  <div className={classNames('services-import__list-custom-rate', {
    'services-import__list-custom-rate-disabled': locked,
  })}
  >
    {sync && !locked ? (
      <Tooltip
        placement="top"
        tooltipClass="tooltip__top"
        text="Sync rate with provider"
      >
        <div className="services-import__list-rate-sync" />
      </Tooltip>
    ) : null}
    {isLoading && !locked
      ? (
        <div className="services-import__list-custom-rate-loading">
          <Spinner />
        </div>
      ) : null}
    <input
      type="text"
      disabled={isLoading || locked}
      onChange={onChange}
      onBlur={onBlur}
      value={isLoading && !locked ? '' : rate || ''}
    />
  </div>
)

CustomRate.propTypes = {
  rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locked: PropTypes.bool,
  isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  sync: PropTypes.bool,
};
export default CustomRate;
